// 数字卡片
<template>
  <div
    class="wrapper-item-card"
    :class="{ 'number-card': !custom }"
    :style="customStyle"
  >
    {{ showNumber.toFixed(0) }}
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  props: {
    // 值
    value: {
      type: Number,
      default: 0,
    },
    // 延时
    delay: {
      type: Number,
      default: 0,
    },
    // 是否自定义样式
    custom: {
      type: Boolean,
      default: false,
    },
    // 自定义样式
    customStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showNumber: 0,
    };
  },
  watch: {
    value: {
      handler(newValue) {
        gsap.to(this, {
          delay: this.delay * 0.4,
          duration: 2.5,
          showNumber: newValue,
        });
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-item-card {
  height: 100%;
  font-weight: bold;
  // font-size: 40px;
  color: #fff;
}
</style>
